import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectLoginService  {
  private accessKey: string | null = null;

  public constructor(
    private router: Router,
    private loginService: LoginService,
  ) { }

  public canActivate(): boolean {
    // todo - check https://github.com/angular/angular/issues/12664 for better approach

    if(this.urlContainBcasToken() && this.accessKey) {
      this.loginService.logIn(this.accessKey);
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

  private urlContainBcasToken(): boolean {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if(params['code']) {
      this.accessKey = params['code'];
      return true;
    }

    return false;
  }

  public assignKeyAndNavigate(key: string): void {
    this.accessKey = key;
    this.loginService.logIn(this.accessKey);
  }
}
